import styled from '@emotion/styled';

import AlertIcon from '@/assets/icons/icon_alert.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.error,
    border: `solid 1px ${defaultTheme.border.color.error}`,
    borderRadius: defaultTheme.border.radius.xs,
    padding: defaultTheme.spacing.xxl,
    color: defaultTheme.color.error,
    textAlign: 'center',
    marginTop: '40px',
  }),
);

export const Icon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${AlertIcon}) no-repeat center`,
    backgroundSize: 'contain',
    marginBottom: defaultTheme.spacing.l,
    width: '36px',
    height: '32px',
    textAlign: 'center',
  }),
);

export const Title = styled.h4(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const ButtonContainer = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    marginTop: defaultTheme.spacing.xxl,
  }),
);
